import React from 'react'
import { MobileNavBar } from "../MobileNavBar";
import AppHeaderLogoComponent from "./AppHeaderLogoComponent";
export function MobileAppHeader() {
    return (
        <>
            <AppHeaderLogoComponent />
            <MobileNavBar />
        </>


    )
}
